import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('reports');
export const actions = helper.createActions('reports', actionTypes);
